import { CRM_API, RequestHelper } from "utils";

export const TerceroService = (() => {
  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get("tercero", params);
    });
  };

  const crear = function (data) {
    return new Promise((res) => res(data)).then((data) => {
      return RequestHelper(CRM_API).post("tercero/CrearTercero", data);
    });
  };

  const actualizar = function (terceroData) {
    return new Promise((res) => res(terceroData)).then((terceroData) => {
      return RequestHelper(CRM_API).post(`tercero/${terceroData.IdSec}`, terceroData);
    });
  };

  const buscarPorId = function (Id) {
    return new Promise((res) => res(Id)).then((IdSec) => {
      return RequestHelper(CRM_API).get(`tercero/${IdSec}`);
    });
  };

  const buscarRNC = function (rnc) {
    return new Promise((res) => res(rnc)).then((rnc) => {
      return RequestHelper(CRM_API).get(`tercero/${rnc}`);
    });
  };

  const listarRNCs = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`tercero/listarRNCs`, params);
    });
  };

  const exportar = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`tercero/exportar`, params, true);
    });
  };

  return { listado, crear, actualizar, buscarPorId, exportar, listarRNCs, buscarRNC };
})();
